// Country list for the phone-number picker.
// Ordering: priority (UG, TZ, KE) → African hubs → rest of Africa → rest of world.
// `dial` is the ITU country code WITHOUT the leading `+`.
// `flag` is the emoji (rendered by the OS/font).
export const COUNTRIES = [
  // ── Priority (East Africa) ─────────────────────────────
  { iso: "UG", name: "Uganda",       dial: "256", flag: "🇺🇬", group: "priority" },
  { iso: "TZ", name: "Tanzania",     dial: "255", flag: "🇹🇿", group: "priority" },
  { iso: "KE", name: "Kenya",        dial: "254", flag: "🇰🇪", group: "priority" },

  // ── Other African hubs ─────────────────────────────────
  { iso: "RW", name: "Rwanda",       dial: "250", flag: "🇷🇼", group: "africa" },
  { iso: "BI", name: "Burundi",      dial: "257", flag: "🇧🇮", group: "africa" },
  { iso: "SS", name: "South Sudan",  dial: "211", flag: "🇸🇸", group: "africa" },
  { iso: "ET", name: "Ethiopia",     dial: "251", flag: "🇪🇹", group: "africa" },
  { iso: "SO", name: "Somalia",      dial: "252", flag: "🇸🇴", group: "africa" },
  { iso: "NG", name: "Nigeria",      dial: "234", flag: "🇳🇬", group: "africa" },
  { iso: "GH", name: "Ghana",        dial: "233", flag: "🇬🇭", group: "africa" },
  { iso: "ZA", name: "South Africa", dial: "27",  flag: "🇿🇦", group: "africa" },
  { iso: "EG", name: "Egypt",        dial: "20",  flag: "🇪🇬", group: "africa" },
  { iso: "MA", name: "Morocco",      dial: "212", flag: "🇲🇦", group: "africa" },
  { iso: "SN", name: "Senegal",      dial: "221", flag: "🇸🇳", group: "africa" },
  { iso: "CI", name: "Côte d'Ivoire",dial: "225", flag: "🇨🇮", group: "africa" },
  { iso: "CM", name: "Cameroon",     dial: "237", flag: "🇨🇲", group: "africa" },
  { iso: "ZM", name: "Zambia",       dial: "260", flag: "🇿🇲", group: "africa" },
  { iso: "ZW", name: "Zimbabwe",     dial: "263", flag: "🇿🇼", group: "africa" },
  { iso: "MZ", name: "Mozambique",   dial: "258", flag: "🇲🇿", group: "africa" },
  { iso: "AO", name: "Angola",       dial: "244", flag: "🇦🇴", group: "africa" },
  { iso: "MW", name: "Malawi",       dial: "265", flag: "🇲🇼", group: "africa" },
  { iso: "MU", name: "Mauritius",    dial: "230", flag: "🇲🇺", group: "africa" },
  { iso: "BW", name: "Botswana",     dial: "267", flag: "🇧🇼", group: "africa" },
  { iso: "NA", name: "Namibia",      dial: "264", flag: "🇳🇦", group: "africa" },
  { iso: "SL", name: "Sierra Leone", dial: "232", flag: "🇸🇱", group: "africa" },
  { iso: "LR", name: "Liberia",      dial: "231", flag: "🇱🇷", group: "africa" },
  { iso: "GA", name: "Gabon",        dial: "241", flag: "🇬🇦", group: "africa" },
  { iso: "TN", name: "Tunisia",      dial: "216", flag: "🇹🇳", group: "africa" },
  { iso: "DZ", name: "Algeria",      dial: "213", flag: "🇩🇿", group: "africa" },
  { iso: "LY", name: "Libya",        dial: "218", flag: "🇱🇾", group: "africa" },
  { iso: "SD", name: "Sudan",        dial: "249", flag: "🇸🇩", group: "africa" },
  { iso: "MG", name: "Madagascar",   dial: "261", flag: "🇲🇬", group: "africa" },
  { iso: "CD", name: "DR Congo",     dial: "243", flag: "🇨🇩", group: "africa" },
  { iso: "CG", name: "Congo",        dial: "242", flag: "🇨🇬", group: "africa" },
  { iso: "TG", name: "Togo",         dial: "228", flag: "🇹🇬", group: "africa" },
  { iso: "BJ", name: "Benin",        dial: "229", flag: "🇧🇯", group: "africa" },
  { iso: "BF", name: "Burkina Faso", dial: "226", flag: "🇧🇫", group: "africa" },
  { iso: "ML", name: "Mali",         dial: "223", flag: "🇲🇱", group: "africa" },
  { iso: "NE", name: "Niger",        dial: "227", flag: "🇳🇪", group: "africa" },
  { iso: "GM", name: "Gambia",       dial: "220", flag: "🇬🇲", group: "africa" },
  { iso: "MR", name: "Mauritania",   dial: "222", flag: "🇲🇷", group: "africa" },
  { iso: "DJ", name: "Djibouti",     dial: "253", flag: "🇩🇯", group: "africa" },
  { iso: "ER", name: "Eritrea",      dial: "291", flag: "🇪🇷", group: "africa" },
  { iso: "LS", name: "Lesotho",      dial: "266", flag: "🇱🇸", group: "africa" },
  { iso: "SZ", name: "Eswatini",     dial: "268", flag: "🇸🇿", group: "africa" },

  // ── Rest of world (searchable) ─────────────────────────
  { iso: "AE", name: "United Arab Emirates", dial: "971", flag: "🇦🇪", group: "world" },
  { iso: "AR", name: "Argentina",   dial: "54",  flag: "🇦🇷", group: "world" },
  { iso: "AT", name: "Austria",     dial: "43",  flag: "🇦🇹", group: "world" },
  { iso: "AU", name: "Australia",   dial: "61",  flag: "🇦🇺", group: "world" },
  { iso: "BD", name: "Bangladesh",  dial: "880", flag: "🇧🇩", group: "world" },
  { iso: "BE", name: "Belgium",     dial: "32",  flag: "🇧🇪", group: "world" },
  { iso: "BR", name: "Brazil",      dial: "55",  flag: "🇧🇷", group: "world" },
  { iso: "CA", name: "Canada",      dial: "1",   flag: "🇨🇦", group: "world" },
  { iso: "CH", name: "Switzerland", dial: "41",  flag: "🇨🇭", group: "world" },
  { iso: "CN", name: "China",       dial: "86",  flag: "🇨🇳", group: "world" },
  { iso: "DE", name: "Germany",     dial: "49",  flag: "🇩🇪", group: "world" },
  { iso: "DK", name: "Denmark",     dial: "45",  flag: "🇩🇰", group: "world" },
  { iso: "ES", name: "Spain",       dial: "34",  flag: "🇪🇸", group: "world" },
  { iso: "FI", name: "Finland",     dial: "358", flag: "🇫🇮", group: "world" },
  { iso: "FR", name: "France",      dial: "33",  flag: "🇫🇷", group: "world" },
  { iso: "GB", name: "United Kingdom", dial: "44", flag: "🇬🇧", group: "world" },
  { iso: "GR", name: "Greece",      dial: "30",  flag: "🇬🇷", group: "world" },
  { iso: "HK", name: "Hong Kong",   dial: "852", flag: "🇭🇰", group: "world" },
  { iso: "ID", name: "Indonesia",   dial: "62",  flag: "🇮🇩", group: "world" },
  { iso: "IE", name: "Ireland",     dial: "353", flag: "🇮🇪", group: "world" },
  { iso: "IL", name: "Israel",      dial: "972", flag: "🇮🇱", group: "world" },
  { iso: "IN", name: "India",       dial: "91",  flag: "🇮🇳", group: "world" },
  { iso: "IR", name: "Iran",        dial: "98",  flag: "🇮🇷", group: "world" },
  { iso: "IT", name: "Italy",       dial: "39",  flag: "🇮🇹", group: "world" },
  { iso: "JP", name: "Japan",       dial: "81",  flag: "🇯🇵", group: "world" },
  { iso: "KR", name: "South Korea", dial: "82",  flag: "🇰🇷", group: "world" },
  { iso: "MX", name: "Mexico",      dial: "52",  flag: "🇲🇽", group: "world" },
  { iso: "MY", name: "Malaysia",    dial: "60",  flag: "🇲🇾", group: "world" },
  { iso: "NL", name: "Netherlands", dial: "31",  flag: "🇳🇱", group: "world" },
  { iso: "NO", name: "Norway",      dial: "47",  flag: "🇳🇴", group: "world" },
  { iso: "NZ", name: "New Zealand", dial: "64",  flag: "🇳🇿", group: "world" },
  { iso: "PH", name: "Philippines", dial: "63",  flag: "🇵🇭", group: "world" },
  { iso: "PK", name: "Pakistan",    dial: "92",  flag: "🇵🇰", group: "world" },
  { iso: "PL", name: "Poland",      dial: "48",  flag: "🇵🇱", group: "world" },
  { iso: "PT", name: "Portugal",    dial: "351", flag: "🇵🇹", group: "world" },
  { iso: "QA", name: "Qatar",       dial: "974", flag: "🇶🇦", group: "world" },
  { iso: "RU", name: "Russia",      dial: "7",   flag: "🇷🇺", group: "world" },
  { iso: "SA", name: "Saudi Arabia",dial: "966", flag: "🇸🇦", group: "world" },
  { iso: "SE", name: "Sweden",      dial: "46",  flag: "🇸🇪", group: "world" },
  { iso: "SG", name: "Singapore",   dial: "65",  flag: "🇸🇬", group: "world" },
  { iso: "TH", name: "Thailand",    dial: "66",  flag: "🇹🇭", group: "world" },
  { iso: "TR", name: "Turkey",      dial: "90",  flag: "🇹🇷", group: "world" },
  { iso: "UA", name: "Ukraine",     dial: "380", flag: "🇺🇦", group: "world" },
  { iso: "US", name: "United States", dial: "1", flag: "🇺🇸", group: "world" },
  { iso: "VN", name: "Vietnam",     dial: "84",  flag: "🇻🇳", group: "world" },
];

export const DEFAULT_COUNTRY = COUNTRIES.find(c => c.iso === "TZ");

// Given a raw E.164 string ("255754510366"), return {country, national}
// so we can render an existing phone value in the picker.
export function splitPhone(e164) {
  if (!e164) return { country: DEFAULT_COUNTRY, national: "" };
  const digits = String(e164).replace(/\D/g, "");
  // longest-prefix match against known dial codes
  const sorted = [...COUNTRIES].sort((a, b) => b.dial.length - a.dial.length);
  for (const c of sorted) {
    if (digits.startsWith(c.dial)) {
      return { country: c, national: digits.slice(c.dial.length) };
    }
  }
  return { country: DEFAULT_COUNTRY, national: digits };
}
